module.exports = __webpack_public_path__ + "static/media/babel.ab496cef.svg";